/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMemo } from "react";
import { getServiceTotalPrice } from "../utils/service";

export const useServicesSummary = (services) => {
  return useMemo(() => {
    if (!services || services.length === 0) return null;

    const groupBookingCount = services.find((service) => service.group_booking_count)?.group_booking_count;
    const getItemsDuration = (service) =>
      [...(service.addons ?? [])]
        .reduce((sum, item) => sum + (item.duration || 0) * (item.qty || 1), 0);
    const totalDuration = services.reduce((acc, service) => acc + service.duration + getItemsDuration(service), 0) || null;

    const totalPrice = services.reduce((acc, service) => acc + getServiceTotalPrice(service, true), 0);

    return {
      count: groupBookingCount ?? services.length,
      duration: totalDuration,
      price: totalPrice,
      currency: services[0].currency,
    };
  }, [services]);
};
